import { getTimeDeviation } from "helpers/firebaseTimeHelper";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { makeSelectDeviation } from "./redux/selectors";
import * as actions from "./redux/actions";

export const ServerTime = () => {
  const dispatch = useAppDispatch();
  const deviation = useSelector(makeSelectDeviation());

  useEffect(() => {
    const syncDeviation = async () => {
      if (deviation === null) {
        const newDeviation = await getTimeDeviation();

        if (!Number.isNaN(newDeviation)) {
          dispatch(actions.syncDeviation(newDeviation));
        }
      }
    };

    syncDeviation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return null;
};
